import { useEffect } from 'react';
import { startSmoothScroll, stopSmoothScroll } from '@/components/feature/smoothScroll';

export default function SmoothScroll() {
  useEffect(() => {
    startSmoothScroll();
    return () => stopSmoothScroll();
  }, []);
  return null;
}